import { actionTypesHubspot as actionTypes } from "../constants/actionTypesHubspot";
import { companyModel } from "../../models/hubspotModel";

const setCompaniesList = (data: Array<companyModel>) => {
  return {
    type: actionTypes.ListOfCompanies,
    payload: data,
  };
};

const setIsCompaniesTableRefreshed = (data: boolean) => {
  return {
    type: actionTypes.IsCompaniesTableRefreshed,
    payload: data,
  };
};

const setSelectedCompany = (data: companyModel) => {
  return {
    type: actionTypes.SelectedCompany,
    payload: data,
  };
};

const setFilteredCompanies = (data: Array<companyModel>) => {
  return {
    type: actionTypes.FilterCompanies,
    payload: data,
  };
};

const setSearchCompanies = (data: Array<companyModel>) => {
  return {
    type: actionTypes.SearchCompanies,
    payload: data,
  };
};

export default {
  setCompaniesList,
  setIsCompaniesTableRefreshed,
  setSelectedCompany,
  setFilteredCompanies,
  setSearchCompanies,
};
